import axios from 'axios';
import api from '../index'

export const adminLogin = (token, data) => axios.post(`${process.env.REACT_APP_BASE_URL}admin/user-login-by-admin`, data, { headers: { 'Authorization': "Bearer " + token } });